import { Link } from "react-router-dom";
import "./Navbar.css";
import { useState } from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import { useRecoilState } from "recoil";
import loginState from "../atoms/Login.atom";

function Navbar() {
  const num = localStorage.getItem("nav");
  const [show, setShow] = useState(num);
  localStorage.setItem("nav", show);
  const [show5, setShow5] = useState(false);
  const userName = localStorage.getItem("user");
  const [log, setLog] = useRecoilState(loginState);

  return (
    <nav className="navbar">
      <div className="container">
        {/* <a className="navbar-brand" href="#">Offcanvas navbar</a> */}
        <button
          className="navbar-toggler hidden"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasNavbar"
          aria-controls="offcanvasNavbar"
          aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="d-flex gap-5 w-100 baba">
          <div className="logo d-flex align-items-center justify-content-center">
            Comfort<span>Limo.</span>
          </div>
          <ul className="d-flex justify-content-between none gap-4 mb-0 py-3 w-100 align-items-center">
            <div className="bobo d-flex justify-content-center gap-4  align-items-center">
              <li className="nav-item">
                <Link
                  to={"/"}
                  className={show === "1" ? "nav-link active" : "nav-link "}
                  onClick={() => {
                    setShow("1");
                  }}
                  aria-current="page">
                  BOOK LIMO
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to={"/services"}
                  className={show === "2" ? "nav-link active" : "nav-link "}
                  onClick={() => {
                    setShow("2");
                  }}>
                  OUR SERVICES
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to={"/fleet"}
                  className={show === "3" ? "nav-link active" : "nav-link "}
                  onClick={() => {
                    setShow("3");
                  }}>
                  OUR FLEET
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to={"/about"}
                  className={show === "4" ? "nav-link active" : "nav-link "}
                  onClick={() => {
                    setShow("4");
                  }}
                  href="#/">
                  ABOUT
                </Link>
              </li>
            </div>
          </ul>
        </div>
        <div
          className="offcanvas offcanvas-start"
          tabindex="-1"
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel">
          <div className="offcanvas-header">
            <h3 className="offcanvas-title" id="offcanvasNavbarLabel">
              Comfort Limo
            </h3>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"></button>
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
              <li className="nav-item">
                <Link to={"/"}>
                  <a
                    className={show === "1" ? "nav-link active" : "nav-link "}
                    onClick={() => {
                      setShow("1");
                    }}
                    aria-current="page"
                    href="#/">
                    BOOK LIMO
                  </a>
                </Link>
              </li>
              <li className="nav-item">
                <Link to={"/services"}>
                  <a
                    className={show === "2" ? "nav-link active" : "nav-link "}
                    onClick={() => {
                      setShow("2");
                    }}
                    href="#/">
                    OUR SERVICES
                  </a>
                </Link>
              </li>
              <li className="nav-item">
                <Link to={"/fleet"}>
                  <a
                    className={show === "3" ? "nav-link active" : "nav-link "}
                    onClick={() => {
                      setShow("3");
                    }}
                    href="#/">
                    OUR FLEET
                  </a>
                </Link>
              </li>
              <li className="nav-item">
                <Link to={"/about"}>
                  <a
                    className={show === "4" ? "nav-link active" : "nav-link "}
                    onClick={() => {
                      setShow("4");
                    }}
                    href="#/">
                    ABOUT
                  </a>
                </Link>
              </li>
            </ul>
            <hr />
            <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
              <li className="nav-item">
                <Link to={"/FAQ"}>
                  <a
                    href="#/"
                    className={show === "5" ? "nav-link active" : "nav-link "}
                    onClick={() => {
                      setShow("5");
                    }}>
                    FAQ
                  </a>
                </Link>
              </li>
              <li className="nav-item">
                <Link to={"/terms"}>
                  <a
                    href="#/"
                    className={show === "6" ? "nav-link active" : "nav-link "}
                    onClick={() => {
                      setShow("6");
                    }}>
                    Terms & Condition
                  </a>
                </Link>
              </li>
              <li className="nav-item">
                <Link>
                  <a
                    href="#/"
                    className={show === "7" ? "nav-link active" : "nav-link "}
                    onClick={() => {
                      setShow("7");
                    }}>
                    Contact Us
                  </a>
                </Link>
              </li>
            </ul>
            <hr />
            {log === true || log === "true" ? (
              <div className="login position-relative">
                <p
                  onClick={() => {
                    setShow5(!show5);
                  }}>
                  Hello {userName} <IoMdArrowDropdown size={"25px"} />
                </p>
                <ul className={show5 ? "" : "none"}>
                  <li
                    onClick={() => {
                      localStorage.setItem("login", false);
                      setLog(false);
                    }}>
                    Logout
                  </li>
                </ul>
              </div>
            ) : (
              <div className="login">
                <Link to={"/login"}>My Account</Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
